// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ArrowDiganolDownIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ArrowDiganolDown/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M18.364 12.707v5.657m0 0h-5.657m5.657 0L5.636 5.636"
}));
export default ArrowDiganolDownIcon;